module.exports = __webpack_public_path__ + "assets/505-bg.2dfa2547.png";